import { lazy } from "react";
import { Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";

const WidgetsPage = lazy(() => import("../Widgets"));

const useWidgetsRoutes = () => (
  <Route path={PATHS.Widgets.Path} element={<WidgetsPage />} />
);

export { useWidgetsRoutes };
